<template>
  <div id="aliParkMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>支付宝车主服务</el-breadcrumb-item>
          <el-breadcrumb-item>停车场管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             class="pageSearch">
      <el-row>
        <el-col :span="22">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;"
                       @change="loadPark($event,true)">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="ISV商户::">
            <el-select v-model="pageSearch.fIsvID"
                       filterable
                       placeholder="请选择ISV商户"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in isv_list"
                         :key="item.fIsvID"
                         :label="item.fMerName"
                         :value="item.fIsvID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入支付宝场库名称"
                      v-model="pageSearch.fParkName"
                      class="search">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="2"
                class="searchRowAdd">
          <el-button type="primary"
                     size="small"
                     v-if="is_edit"
                     @click="handleAdd">新增支付宝场库
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号"
                           align="right">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80">
          </el-table-column>
          <el-table-column prop="fMerName"
                           label="ISV商户">
          </el-table-column>
          <el-table-column prop="fAliParkID"
                           width="180px"
                           label="支付宝场库ID">
          </el-table-column>
          <el-table-column prop="fParkName"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fAliParkType"
                           label="场库类型">
          </el-table-column>
          <el-table-column prop="fParkPhone"
                           label="客服电话">
          </el-table-column>
          <el-table-column prop="fAliPayType"
                           label="支付方式">
          </el-table-column>
          <el-table-column prop="fAddress"
                           label="场库地址">
          </el-table-column>
          <el-table-column prop="fParkFeeDesc"
                           label="收费说明">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="160">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         type="warning"
                         v-if="is_edit"
                         @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               top="7vh"
               width="50%"
               v-dialogDrag
               :visible.sync="dialogFormVisible">
      <el-form :model="parking"
               :rules="rules"
               ref="ruleForm"
               label-width="140px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户::"
                          prop="fCustID">
              <el-select v-model="parking.fCustID"
                         :disabled="formIsEdit"
                         style="width:100%;"
                         filterable
                         placeholder="请选择客户"
                         @change="loadPark($event,false)">
                <el-option v-for="item in cust_list"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="场库::"
                          prop="fParkID">
              <el-select v-model="parking.fParkID"
                         :disabled="formIsEdit"
                         filterable
                         style="width:100%;"
                         placeholder="请选择场库"
                         @change="changePark">
                <el-option v-for="item in form_park_list"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="ISV商户::"
                          prop="fIsvID">
              <el-select v-model="parking.fIsvID"
                         :disabled="formDisabled"
                         style="width:100%;"
                         filterable
                         placeholder="请选择ISV商户"
                         @change="changeIsv">
                <el-option v-for="item in isv_list"
                           :key="item.fIsvID"
                           :label="item.fMerName"
                           :value="item.fIsvID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户PID::"
                          prop="fAgentID">
              <el-input v-model="parking.fAgentID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="场库名称::"
                          prop="fParkName">
              <el-input v-model="parking.fParkName"
                        :disabled="formDisabled"
                        placeholder="请填写场库名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="场库类型::"
                          prop="fAliParkType">
              <el-select v-model="parking.fAliParkType"
                         :disabled="formDisabled"
                         style="width:100%;"
                         filterable
                         placeholder="请选择场库">
                <el-option v-for="item in aliParkType_list"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="收款方PID::"
                          prop="fMchntID">
              <el-input v-model="parking.fMchntID"
                        :disabled="formDisabled"
                        placeholder="请填写收款方PID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客服电话::"
                          prop="fParkPhone">
              <el-input v-model="parking.fParkPhone"
                        :disabled="formDisabled"
                        placeholder="请填写客服电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="20">
                <el-form-item label="高德地图标识::"
                              prop="fAliPoiid">
                  <el-input v-model="parking.fAliPoiid"
                            :disabled="formDisabled"
                            placeholder="请填写高德地图唯一标识"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-link type="primary"
                         id="link_btn"
                         :underline="false"
                         href="https://openclub.alipay.com/club/history/read/5150"
                         target="_blank"> 如何获取？</el-link>

              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付方式::"
                          prop="fAliPayTypeArray">
              <el-select v-model="parking.fAliPayTypeArray"
                         :disabled="formDisabled"
                         style="width:100%;"
                         multiple
                         placeholder="请选择支付方式">
                <el-option v-for="item in aliPayType_list"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商圈ID::"
                          prop="fAliMallID">
              <el-input v-model="parking.fAliMallID"
                        :disabled="formDisabled"
                        placeholder="请填写商圈ID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="离场超时::"
                          prop="fTimeOut">
              <el-input v-model="parking.fTimeOut"
                        :disabled="formDisabled"
                        placeholder="请填写离场超时(以分钟为单位)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="总车位::"
                          prop="fSumSpace">
             <el-input v-model="parking.fSumSpace"
                        :disabled="formDisabled"
                        placeholder="请填写总车位"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否支持电子发票::"
                          prop="fIsSupportInvoice">
          <el-radio-group v-model="parking.fIsSupportInvoice">
              <el-radio label="0">不支持</el-radio>
              <el-radio label="1">支持</el-radio>
           </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否支持先离后付::"
                          prop="fIsSupportAfterPay">
            <el-radio-group v-model="parking.fIsSupportAfterPay">
              <el-radio label="0">不支持</el-radio>
              <el-radio label="1">支持</el-radio>
           </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
       <el-row >
          <el-col :span="24">
            <el-form-item  class="img_row" label="停车价格图片::"
                          prop="fFeeDescriptionImg"
                          style="margin-bottom:0px;">
              <el-upload class="avatar-uploader"
                         action="javascript(0)"
                         :show-file-list="false"
                         :disabled="formDisabled"
                         :before-upload="beforeAvatarUpload">
                <img v-if="(parking.fFeeDescriptionImg||'').length>0"
                     :src="parking.fFeeDescriptionImg"
                     class="avatar">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label=" ">
              <el-button @click="parking.fFeeDescriptionImg=''"
                         type="danger"
                         icon="el-icon-delete"
                         style="padding:5px;"
                         :disabled="formDisabled"
                         circle></el-button>&nbsp;<span style="color:red;font-size:12px;">图片必须为png格式，大小不要超过1MB</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="场库地址::"
                          prop="fAddress">
              <el-input v-model="parking.fAddress"
                        :disabled="formDisabled"
                        placeholder="请填写场库地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fkey_row">
          <el-col :span="24">
            <el-form-item label="收费说明::"
                          prop="fParkFeeDesc">
              <el-input type="textarea"
                        v-model="parking.fParkFeeDesc"
                        :disabled="formDisabled"
                        class="fkey"
                        placeholder="请填写收费说明"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-footer"
           slot="footer">
        <el-button type="primary"
                   @click="submitForm('ruleForm')"
                   v-if="!formDisabled">保存</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
      <!-- <el-row style="margin-top:-1px">
        <el-col :span="12">
          <div class="tab_foot">&nbsp;</div>
        </el-col>
        <el-col :span="12">
          <div class="dialog-footer">
            <el-button type="primary"
                       @click="submitForm('ruleForm')"
                       v-if="!formDisabled">保存</el-button>
            <el-button @click="dialogFormVisible = false">取消</el-button>
          </div>
        </el-col>
      </el-row> -->
    </el-dialog>
  </div>
</template>
<script>
import { aliParking as api } from '../../api/aliParking'
import { setting } from '../../api/setting'
import * as user from '../../api/user'
import * as park from '../../api/park'
export default {
  data () {
    var validateNum = (rule, value, callback) => {
      if ((this.parking.fTimeOut || '').length > 0) {
        var re = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
        if (!re.test(value)) {
          callback(new Error('请填写数字格式'))
        }
      }
      callback()
    }
    var validateNum1 = (rule, value, callback) => {
      if ((this.parking.fSumSpace || '').length > 0) {
        var re = /^\+?[1-9][0-9]*$/
        if (!re.test(value)) {
          callback(new Error('请填写正整数数字格式'))
        }
      }
      callback()
    }
    return {
      is_edit: false,
      is_del: false,
      is_syn: false,
      formDisabled: false,
      formIsEdit: false,
      tableHeight: 0,
      cust_list: '',
      park_list: '',
      isv_list: [],
      form_park_list: [],
      aliPayType_list: [{ label: '在线缴费', value: '1' }, { label: '代扣缴费', value: '2' }, { label: '当面付', value: '3' }],
      aliParkType_list: [
        { label: '居民小区', value: '1' },
        { label: '商圈停车场', value: '2' },
        { label: '路侧停车场', value: '3' },
        { label: '公园景点', value: '4' },
        { label: '商务楼宇', value: '5' },
        { label: '其他', value: '6' },
        { label: '交通枢纽', value: '7' },
        { label: '市政设施', value: '8' }
      ],
      dialogFormVisible: false,
      loading: true,
      dialogTitle: '',
      pageData: [],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fParkID: '',
        fIsvID: '',
        fParkName: ''
      },
      parking: {
        fCustID: '',
        fParkID: '',
        fIsvID: '',
        fAddress: '',
        fAliParkType: '',
        fAliPoiid: '',
        fParkPhone: '',
        fAliPayType: '',
        fAliPayTypeArray: [],
        fAliMallID: '',
        fParkFeeDesc: '',
        fParkName: '',
        fTimeOut: '',
        fMchntID: '',
        fAgentID: '',
        fSumSpace: '',
        fIsSupportInvoice: '0',
        fIsSupportAfterPay: '0',
        fFeeDescriptionImg: ''

      },
      rules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        fParkID: [
          { required: true, message: '请选择场库', trigger: 'change' }
        ],
        fIsvID: [
          { required: true, message: '请选择ISV商户', trigger: 'change' }
        ],
        fParkName: [
          { required: true, message: '请输入场库名称', trigger: 'blur' }
        ],
        fAliParkType: [
          { required: true, message: '请选择场库类型', trigger: 'change' }
        ],
        fMchntID: [
          { required: true, message: '请输入收款方PID', trigger: 'blur' }
        ],
        fParkPhone: [
          { required: true, message: '请输入客服电话', trigger: 'blur' }
        ],
        fIsSupportInvoice: [
          { required: true, message: '请选择是否支持电子发票', trigger: 'blur' }
        ],
        fIsSupportAfterPay: [
          { required: true, message: '请选择是否支持先离后付', trigger: 'blur' }
        ],
        fAliPayTypeArray: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ],
        fTimeOut: [
          { validator: validateNum, trigger: 'blur' }
        ],
        fSumSpace: [
          { validator: validateNum1, trigger: 'blur' }
        ],
        fAddress: [
          { required: true, message: '请输入场库地址', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      api.aliParkingPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：加载支付宝场库信息失败')
          }
        }
      })
    },
    changeIsv (fIsvID) {
      var isvList = this.isv_list.filter(r => r.fIsvID === fIsvID)
      if (isvList && isvList.length > 0) {
        this.parking.fAgentID = isvList[0].fPid
      }
    },
    beforeAvatarUpload (file) {
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 <= 1024

      if (!isPNG) {
        this.$message.error('上传图片只能是 PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
        return false
      }
      if (isPNG && isLt2M) {
        // 显示图片
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          this.parking.fFeeDescriptionImg = reader.result
        }
      }
      return false
    },
    loadPark (fCustID, isSearch) {
      if (isSearch) {
        this.pageSearch.fParkID = ''
        this.park_list = []
      } else {
        this.parking.fParkID = ''
        this.form_park_list = []
      }
      // 加载在场数据列表
      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (isSearch) {
              this.park_list = data.Data || []
            } else {
              this.form_park_list = data.Data || []
            }
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    changePark (fParkID) {
      var park = this.form_park_list.filter(r => r.fParkID === fParkID)
      if (park && park.length > 0) {
        this.parking.fAddress = park[0].fAddress
        this.parking.fParkPhone = park[0].fLinkPhone
        this.parking.fParkName = park[0].fParkName
        this.parking.fSumSpace = park[0].fParkCount
        switch (park[0].fParkTypeID) {
          case '100':
            this.parking.fAliParkType = '1'
            break
          case '101':
            this.parking.fAliParkType = '5'
            break
          case '102':
            this.parking.fAliParkType = '2'
            break
          case '103':
            this.parking.fAliParkType = '4'
            break
          case '104':
            this.parking.fAliParkType = '8'
            break
          case '129':
            this.parking.fAliParkType = '6'
            break
          case '310':
            this.parking.fAliParkType = '3'
            break
          default:
            this.parking.fAliParkType = ''
            break
        }
      }
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    handleInfo (index, row) {
      this.dialogTitle = '【' + row.fParkName + '】查看支付宝场库信息'
      this.formIsEdit = true
      this.formDisabled = true
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.dialogFormVisible = true
      api.aliParkingInfo(row.fBigRowID).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            var park = data.Data || {}
            this.loadPark(park.fCustID, false)
            park.fAliPayTypeArray = (park.fAliPayType || '').split(',')
            this.parking = park
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    handleEdit (index, row) {
      this.dialogTitle = '【' + row.fParkName + '】编辑支付宝场库信息'
      this.formIsEdit = true
      this.formDisabled = false
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.dialogFormVisible = true
      api.aliParkingInfo(row.fBigRowID).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            var park = data.Data || {}
            this.loadPark(park.fCustID, false)
            park.fAliPayTypeArray = (park.fAliPayType || '').split(',')
            this.parking = park
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    handleAdd () {
      this.dialogTitle = '新增支付宝场库'
      this.parking = {
        fCustID: '',
        fParkID: '',
        fIsvID: '',
        fAddress: '',
        fAliParkType: '',
        fAliPoiid: '',
        fParkPhone: '',
        fAliPayType: '',
        fAliPayTypeArray: [],
        fAliMallID: '',
        fParkFeeDesc: '',
        fParkName: '',
        fTimeOut: '',
        fMchntID: '',
        fAgentID: '',
        fIsSupportInvoice: '0',
        fIsSupportAfterPay: '0',
        fFeeDescriptionImg: '',
        fSumSpace: ''
      }
      setTimeout(() => {
        if (this.$refs['ruleForm']) {
          this.$refs['ruleForm'].clearValidate()
        }
      }, 50)
      this.formIsEdit = false
      this.formDisabled = false
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formDisabled) { return }
          this.parking.fAliPayType = this.parking.fAliPayTypeArray.join()
          api.aliParkingEdit(this.parking).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogFormVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.init()
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 220
      obj.tableHeight = clientHeight
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 90000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
    park.getCustByGroup().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.cust_list = data.Data || []
        } else {
          this.$message.error('提示：加载客户列表失败')
        }
      }
    })
    setting.aliPayISVList().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.isv_list = data.Data || []
        } else {
          this.$message.error('提示：加载ISV商户列表失败')
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#aliParkMain .el-dialog {
  min-width: 920px;
}
#aliParkMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#aliParkMain .el-dialog__title {
  color: white;
}
#aliParkMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#aliParkMain .el-dialog__body {
  padding: 30px 20px 0px 20px;
}
#aliParkMain .is-disabled .el-input__inner,
#aliParkMain .is-disabled .el-textarea__inner {
  color: #606266;
}

#aliParkMain .fRemark > .el-textarea__inner {
  height: 180px;
}
#aliParkMain .fRemark_row .el-form-item__content {
  height: 180px;
}
#aliParkMain .fkey > .el-textarea__inner {
  height: 60px;
}
#aliParkMain .fkey_row .el-form-item__content {
  height: 60px;
}
/* 上传图片 */
#aliParkMain .img_row .el-form-item__content {
  height: 180px;
}
#aliParkMain .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  line-height: 160px;
}
#aliParkMain .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
#aliParkMain .avatar-uploader-icon {
  font-size: 10px;
  color: #8c939d;
  width: 160px;
  height: 160px;
  line-height: 160px;
  text-align: center;
}
#aliParkMain .avatar {
  width: 160px;
  height: 160px;
  display: block;
}
</style>
<style scoped>
#link_btn {
  height: 32px;
  line-height: 32px;
  padding-left: 3px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 300px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/aliParking/aliParkMain.vue